import Icon from '../components/Icon.vue'

Icon.register({
  'user-alt-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M633.8 458.1c7 5.4 8.3 15.5 2.9 22.3l-19.6 25.3c-5.5 7-15.5 8.2-22.5 2.8l-588.4-454.7c-7-5.4-8.2-15.4-2.8-22.4l19.6-25.2c5.5-7 15.5-8.2 22.5-2.8l135.5 104.8c16-62.1 71.9-108.2 139-108.2 79.5 0 144 64.5 144 144 0 54.1-30.2 100.7-74.4 125.3zM198.4 320h47.4l248.4 192h-382.2c-26.5 0-48-21.5-48-48v-9.6c0-74.2 60.2-134.4 134.4-134.4z'
      }
    ]
  }
})
